import React, { CSSProperties } from "react";
import { TimeDTO } from "../../interfaces/TimeDTO";
import { TimingPositionsDTO } from "../../interfaces/TimingPositionsDTO";
import { formatTime } from "../../services/timeHandler";
import { AthleteDTO } from "../../interfaces/AthletesDTO";

interface Props {
  time: TimeDTO;
  tposes: TimingPositionsDTO | null;
  timingPrecision: string;
  lastRank:number;
  athlete: AthleteDTO | null;
}

export const BiosTableRow = ({ time, tposes, timingPrecision,lastRank,athlete }: Props) => {

  const getDegres = ():number => {
    //tom 
    if (lastRank < 0){
      return 90;
    }
    else if (lastRank == time.RankClass){
      //samma placering
      return 90;
    }
    else if ((lastRank - time.RankClass) < 0){
      //Sämre placering
      return 180;
    }
    else if ((lastRank - time.RankClass) > 0){
      //bättre 
      return 0;
    }
    return 0;
  }
  const getFill = ():string => {
    if (lastRank < 0){
      return "#000000";
    }
    else if (lastRank == time.RankClass){
      //samma placering
      return "rgb(167,172,28)";
    }
    else if ((lastRank - time.RankClass) < 0){
      //Sämre placering
      return "#ff0000";
    }
    else if ((lastRank - time.RankClass) > 0){
      //bättre 
      return "#58e30d";
    }
    return "#000000";
  }

  const style: CSSProperties = {
    
    color: "red",
    display: tposes?.Ipos == 1 ? "none" : "blcok"
  };

  let MaxRanked: number | null = tposes
    ? Math.max(...tposes.TimePass.map((o) => o.RankClass))
    : null;
  if (tposes == null) {
    return <></>;
  }
  // let dav = time.Ipos in athlete!.IposRankSortOrder ?  athlete!.IposRankSortOrder[time.Ipos] : null;
  let dav2 = null; // dav ? dav.timetopass : null;
  return (
    <tr className="bios-time-row">
      <td className="bios-time-row-position">{tposes.Name}{dav2 ? formatTime(dav2,timingPrecision) : null }</td>
      <td className="bios-time-row-rank">
        {MaxRanked ? time.RankClass + "/" + MaxRanked : time.RankClass}
      </td>
      <td className="bios-time-row-trend" style={{display: lastRank < -2 ? "none" : ""}}>
        <span style={style}>
          <svg
            fill={getFill()}
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            width="27px"
            height="17px"
            viewBox="0 0 60.731 60.731"
            style={{transform:"rotate(" + getDegres()  + "deg)" }}
          >
            <g>
              <g>
                <polygon points="30.366,0 0.625,29.735 17.998,29.735 18.003,60.731 42.733,60.729 42.733,29.735 60.107,29.735 		" />
              </g>
            </g>
          </svg>
        </span>
      </td>
      <td className="bios-time-row-time">
        {formatTime(time.RunTime, timingPrecision)}
      </td>
      <td className="bios-time-row-diff">
        {formatTime(time.DiffClass, timingPrecision)}
      </td>
    </tr>
  );
};
